import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const coverageSubmissionList = (params = '') => Http.get(`/showcase-coverage-submissions${serialize(params)}`)
export const coverageSubmissionByID = (params = '') => Http.get(`/showcase-coverage-submissions/${params}`)
export const coverageSubmissionApprove = (id, data = {}) => Http.post(`/showcase-coverage-submissions/${id}/approve`, data)
export const coverageSubmissionReject = (id, data = {}) => Http.post(`/showcase-coverage-submissions/${id}/reject`, data)
